<template>
  <div>
    <h1>NFT link visualizer</h1>
    <ad />
    <h3>
      You can enter an XRPL NFT Token Id to see if it has any NFTs linking to
      it.
    </h3>

    <div class="spinner-displayer">
      <img src="@/assets/images/logo.png" width="75" />
    </div>
    <form id="findNftsForm" @submit.prevent="findNfts">
      <div>
        <h2>NFT Token Id</h2>
        <input
          title="Enter an NFT Token id to search"
          type="text"
          v-model="nftTokenId"
          class="form-control form-control-lg"
        />
      </div>
      <label v-html="message" />
      <button type="submit" id="btn" :disabled="false">Find NFTstitches</button>
    </form>
    <div v-if="isShow">
      <div ref="graphContainer" class="graph-container">
        <svg width="800" height="300"></svg>
      </div>
    </div>
    <div>
      <table border="1">
        <tr>
          <td><h2>Image</h2></td>
          <td><h2>Name</h2></td>
          <td><h2>Description</h2></td>
          <td>
            <h2>NFT Token Id</h2>
          </td>
          <td><h2>This NFT Links To</h2></td>
        </tr>
        <tr v-for="result in results" :key="result.cidMeta">
          <td>
            <h3>
              <img
                v-bind:src="'https://ipfs.io/ipfs/' + result.cidNft"
                width="20%"
              />
            </h3>
          </td>
          <td>
            <h3>{{ result.name }}</h3>
          </td>
          <td>
            <div v-if="result.description">
              <h3>{{ result.description }}</h3>
            </div>
          </td>
          <td>
            <div v-if="result.xrpNftId">
              <h3>{{ result.xrpNftId }}</h3>
            </div>
          </td>
          <td>
            <ul>
              <li v-for="prop in result.props" :key="prop.id">
                <div v-if="prop.key == 'nftlink_tokenid'">
                  <h3>{{ prop.value }}</h3>
                </div>
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style>
.graph-container {
  margin-top: 10px; /* Adjust the margin-top to move the graph higher */
}
</style>

<script>
import ad from "../components/ad.vue";
import * as d3 from "d3";

export default {
  name: "xrplnft",
  data: function () {
    return {
      results: "",
      message: "",
      isShow: true,
      wantNft: "",
      isShowWant: false,
      xrplExplorer: "https://bithomp.com/explorer/",
      active: false,
      nftTokenId: "",
      graph: {},
      graphContainer: {},
    };
  },

  components: {
    ad,
  },
  methods: {
    dataToNodes: function (d) {
      // Clear existing graph
      d3.select(this.$refs.graphContainer)
        .select("svg")
        .selectAll("*")
        .remove();

      this.graph = { nodes: [], links: [] };

      for (var i = 0; i < d.length; i++) {
        this.graph.nodes.push({ name: d[i].xrpNftId, cidNft: d[i].cidNft });
        if (d[i].props) {
          for (var p = 0; p < d[i].props.length; p++) {
            if (
              d[i].props[p].key &&
              d[i].props[p].value &&
              d[i].props[p].key === "nftlink_tokenid"
            ) {
              // Check if the target node exists
              const targetNodeExists = d.some(
                (node) => node.xrpNftId === d[i].props[p].value
              );

              if (targetNodeExists) {
                this.graph.links.push({
                  source: d[i].xrpNftId,
                  target: d[i].props[p].value,
                });
              }
            }
          }
        }
      }

      console.log(JSON.stringify(this.graph));

      var svg = d3.select(this.$refs.graphContainer).select("svg"); // Modify this line
      var width = svg.attr("width");
      var height = svg.attr("height");
      this.graphContainer = d3
        .forceSimulation(this.graph.nodes)
        .force(
          "link",
          d3
            .forceLink(this.graph.links)
            .id(function (d) {
              return d.name;
            })
            .strength(5) // Increase the strength to spread out the links
        )
        .force("charge", d3.forceManyBody().strength(-3000)) // Decrease the strength to spread out the nodes
        .force("center", d3.forceCenter(width / 2, height / 2))
        .on("tick", ticked);

      var link = svg
        .append("g")
        .selectAll("line")
        .data(this.graph.links)
        .enter()
        .append("line")
        .attr("stroke-width", function () {
          return 3;
        })
        .style("stroke", "pink");

      var node = svg
        .append("g")
        .selectAll("image")
        .data(this.graph.nodes)
        .enter()
        .append("g")
        .attr("class", "node-group");

      // Add images to nodes
      node
        .append("image")
        .attr("xlink:href", function (d) {
          return "https://ipfs.io/ipfs/" + d.cidNft; // Assuming 'cidNft' contains the image URL
        })
        .attr("width", 30) // Increase the width of the image
        .attr("height", 30) // Increase the height of the image
        .attr("x", -15) // Adjust the horizontal position of the image
        .attr("y", -15); // Adjust the vertical position of the image

      function ticked() {
        link
          .attr("x1", function (d) {
            return d.source.x;
          })
          .attr("y1", function (d) {
            return d.source.y;
          })
          .attr("x2", function (d) {
            return d.target.x;
          })
          .attr("y2", function (d) {
            return d.target.y;
          });

        // Update both circles and text elements
        node.attr("transform", function (d) {
          return "translate(" + d.x + "," + d.y + ")";
        });
      }
    },

    findNfts: function () {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };
      fetch(
        this.$nfthost + "/nftstitches/nft/" + this.nftTokenId,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          document
            .querySelector(".spinner-displayer")
            .classList.remove("loading");

          if (data.status && data.status != 200) {
            this.message = data.message;
            return;
          }
          console.log(data);
          if (!data || data.length <= 0) {
            this.message = "Fetch failed, please retry";
          } else {
            this.results = data;

            this.dataToNodes(data);

            this.isShowResults = true;
          }
        })
        .catch((e) => {
          document
            .querySelector(".spinner-displayer")
            .classList.remove("loading");
          this.message = e;
        });
    },
    spinner: function () {
      const spinnerDisplayer = document.querySelector(".spinner-displayer");
      spinnerDisplayer.classList.add("loading");
    },
    preload: function () {
      this.nftTokenId =
        "00090000A6EA2C06E50D5BD623E8AC925D738C32CE6131400981978F0516DFB1";
      this.findNfts();
    },
  },
  mounted() {
    this.preload();
  },
};
</script>


